// Valid lat long string example: "-172.324123, 288.123981"

import { isNA } from "./na-converter"

export function isLatLongFormatted(string){
  const stringIsNA = isNA(string)
  const isPlusCode = string.includes('+')
  const isLatLongCompact = string.includes(',')
  const isLatLong = string.includes(', ')
  const isNotString = typeof string !== 'string'

  if(isNotString){
    console.warn('!WARNING: Location with non-string as pinLocation', {string})
    return false
  }

  if(stringIsNA){
    console.warn('!WARNING: Location with N/A as pinLocation', {string})
    return false
  }

  if(isPlusCode){
    console.warn('!WARNING: Plus Code detected.', {string})
    return false
  }

  if(isLatLongCompact){
    const splitted = string.split(',')

    if(splitted && splitted.length === 2){
      if(splitted[0] === null || splitted[1] === null){
        return false
      } else {
        return 'compact'
      }
    } else {
      return false
    }
  }

  if(isLatLong){
    const splitted1 = string.split(', ')

    if(splitted1 && splitted1.length === 2){
      if(splitted1[0] === null || splitted1[1] === null){
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }

  console.warn('Unknow location format: ', {string})
  return true
}

export function getCoordinateObject(string){
  if(isLatLongFormatted(string)){
    if(isLatLongFormatted(string) === 'compact'){
      return {
        lat: parseFloat(string.split(',')[0]),
        lng: parseFloat(string.split(',')[1])
      }
    } else {
      return {
        lat: parseFloat(string.split(', ')[0]),
        lng: parseFloat(string.split(', ')[1])
      }
    }
  }

  return false
}
